import React from 'react';
import CompletedGradeNeeded from "../../components/CompletedGradeNeeded";
import './NeedsGreaded.css';

const NeedsGreaded = () => {
    return (
        <div className="needs-graded-page">
            <CompletedGradeNeeded />
        </div>
    );
};

export default NeedsGreaded;